import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface ItemProps {
  className?: string;
  label: string;
  value: string | number;
}

export const Item = (props: ItemProps) => {
  return (
    <li className={cn('flex flex-col', props.className)}>
      <Text size='2xl'>{props.value}</Text>
      <Text weight={PaletteUtils.getPaletteParam('medium', 'semibold')} color={PaletteUtils.getPaletteParam('secondary', 'secondary-light')}>
        {props.label}
      </Text>
    </li>
  );
};
